module.exports = __webpack_public_path__ + "img/cjjm_biaoti.1816b4e4.png";